/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionDownloadUrlQueryResponse, FilesControllerGetFileRenditionDownloadUrlPathParams, FilesControllerGetFileRenditionDownloadUrlQueryParams } from "../../models/filesController/FilesControllerGetFileRenditionDownloadUrl";

function getFilesControllerGetFileRenditionDownloadUrlUrl(id: FilesControllerGetFileRenditionDownloadUrlPathParams["id"], renditionId: FilesControllerGetFileRenditionDownloadUrlPathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/renditions/${renditionId}/download-url` as const }  
  return res
}

/**
 * @description Returns a pre-signed S3 URL for downloading the file rendition.
 * @summary Get a signed download URL for a file rendition
 * {@link /api/v1/files/:id/renditions/:renditionId/download-url}
 */
export async function filesControllerGetFileRenditionDownloadUrl(id: FilesControllerGetFileRenditionDownloadUrlPathParams["id"], renditionId: FilesControllerGetFileRenditionDownloadUrlPathParams["renditionId"], params?: FilesControllerGetFileRenditionDownloadUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetFileRenditionDownloadUrlQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getFilesControllerGetFileRenditionDownloadUrlUrl(id, renditionId).url.toString(), params, ... requestConfig })  
  return res.data
}